/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedCatalogArchivedAdmin } from './PaginatedCatalogArchivedAdmin'
import {
  PaginatedCatalogArchivedAdminFromJSON,
  PaginatedCatalogArchivedAdminFromJSONTyped,
  PaginatedCatalogArchivedAdminToJSON,
} from './PaginatedCatalogArchivedAdmin'

/**
 *
 * @export
 * @interface EnvelopedArchivedCatalogCatalogArchivedAdmin
 */
export interface EnvelopedArchivedCatalogCatalogArchivedAdmin {
  /**
   *
   * @type {PaginatedCatalogArchivedAdmin}
   * @memberof EnvelopedArchivedCatalogCatalogArchivedAdmin
   */
  body: PaginatedCatalogArchivedAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedArchivedCatalogCatalogArchivedAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedArchivedCatalogCatalogArchivedAdmin interface.
 */
export function instanceOfEnvelopedArchivedCatalogCatalogArchivedAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedArchivedCatalogCatalogArchivedAdminFromJSON(
  json: any,
): EnvelopedArchivedCatalogCatalogArchivedAdmin {
  return EnvelopedArchivedCatalogCatalogArchivedAdminFromJSONTyped(json, false)
}

export function EnvelopedArchivedCatalogCatalogArchivedAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedArchivedCatalogCatalogArchivedAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedCatalogArchivedAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedArchivedCatalogCatalogArchivedAdminToJSON(
  value?: EnvelopedArchivedCatalogCatalogArchivedAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedCatalogArchivedAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
